import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const AiaHandler = () => {
  const location = useLocation();
  const DEFAULT_AFF_ID = "1376";
  const params = new URLSearchParams(location.search);
  const culture = params.get("culture");
  const authRedirectUrl = process.env.REACT_APP_AIA_AUTH_REDIRECT_URL;
  if (!authRedirectUrl) {
    throw new Error("REACT_APP_AIA_AUTH_REDIRECT_URL environment variable is not set.");
  }
  const rawRedirectUrl = params.get("redirectUrl");
  let redirectUri;
  if (rawRedirectUrl) {
    const separator = rawRedirectUrl.includes("?") ? "&" : "?";
    redirectUri = `${authRedirectUrl}?redirectUrl=${encodeURIComponent(rawRedirectUrl)}${separator}flowType=amazon`;
  } else {
    redirectUri = authRedirectUrl;
  }
  let affid = params.get("affid");
  if (!affid || affid === "0") {
    affid = DEFAULT_AFF_ID;
  }
  const authProperty = {
    action: "force_verification",
    cc: {
      Mode: "register",
      SignUp: {
        HideLoginCTA: true
      }
    }
  };

  const serializedAai = JSON.stringify(authProperty, (key, value) =>
    value === null ? undefined : value // Ignore null values
  );
  const { loginWithRedirect } = useAuth0();
  useEffect(() => {
    loginWithRedirect({
      appState: {},
      authorizationParams: {
        aai: serializedAai,
        "ext-contextid": '5c0dc54d-3419-4e6c-ae4c-5b0bd30b68e2',
        ...(culture ? { "ui_locales": culture } : {}),
        redirectUri,
        "ext-affid": affid,
        max_age: 900
      }
    });
  }, [loginWithRedirect, serializedAai, culture, redirectUri, affid]);
  return null;
};

export default AiaHandler;
